<template>
    <div>
        <el-dialog
            :modal-append-to-body="false"
            append-to-body
            title="标识码"
            :visible.sync="show"
            width="200mm"
            :before-close="handleClose">
            <div class="dialog-footer" v-loading="loading" >
                <el-button @click="show = false">取 消</el-button>
                <el-button style="margin-left:10px" type="primary"   @click="print">打 印</el-button>
            </div>

            <div ref="print" id="qrcodeBox" v-loading="loading"
            v-if="show">
                <div id="printBox">
                    <div class="page" id="page" v-for="(item,index) in qrcodeList" :key="item">
                        <div class="tabel">
                            <div class="header">
                                <div style="width:45px;"></div>
                                <span>{{item.projectName}}</span>
                                <span style="font-size:12px;">

                                    {{moduleType==1?'区域':'设备'}}
                                </span>
                            </div>
                            <div class="tbody-box">
                                <div class="td-qrcode" :id="'qrcode'+index">
                                    {{getQrcodeBydom(index,item)}}
                                </div>
                                <div class="td-text">
                                    <li class="first-li2" v-if="moduleType==1">
                                        {{moduleType==1?item.areaFullName:item.name}}

                                    </li>
                                    <li class="first-li" v-else :style="{height: (item.model ? '19mm':'29mm')}">
                                        {{moduleType==1?item.areaFullName:item.name}}
                                    </li>
                                    <li v-if="moduleType == 0 && item.model" class="module-li">
                                        {{item.model}}
                                    </li>
                                    <li :style="'font-size:'+ item.codeSize +'px;'" >{{item.codeNo}}</li>
                                    <li class="dept-li">{{item.deptName}}</li>
                                    <li class="last-li" v-if="moduleType==0"> {{item.areaFullName}}</li>
                                </div>
                            </div>
                        </div>

                    </div>
               </div>
            </div>

        </el-dialog>
    </div>
</template>

<style>
    #qrcodeBox img{
        width: 100%;
        height: 100%;
    }
</style>
<style scoped>

    li{
        list-style: none;
        min-height: 10mm;
        height: 10mm;
        line-height: 10mm;
        padding: 0 5px;
        width: 37mm;
        border-top: 1px solid #000;

    }
    .tbody-box{
        display: flex;
    }
    td{
        padding: 0;
    }
    .tabel{
        height: 100%;
        width: 100%;
        font-weight: bold;
        border: 1px solid #000;
    }
    .header{
        display: flex;
        height: 10mm;
        line-height: 10mm;
        font-size: 16px;
        letter-spacing:4px;
        justify-content: space-between;
    }
    .td-qrcode{
        height: 54mm;
        width: 54mm;
        margin: 0;
        padding: 3mm 3mm 3mm 3mm;

        flex-shrink: 0;
        flex-grow: 0;
        border-top: 1px solid #000;

    }
    .td-text{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        font-size: 16px;
        border-top: 1px solid #000;
        border-left: 1px solid #000;
        flex-shrink: 1;
        flex-grow: 1;

    }
    .first-li{
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        border:none;
        flex-grow:0;
        flex-shrink: 0;
        word-wrap: break-word;
        word-break: break-all;
        height:29mm;
    }
    .module-li{
        font-size: 12px;
    }
    .first-li2{
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        border:none;
        flex-grow:0;
        flex-shrink: 0;
        word-wrap: break-word;
        word-break: break-all;
        height:39mm;
    }
    .last-li{
        flex-shrink: 0;
        flex-grow: 0;
        max-height: 10mm;
        overflow: hidden;

    }
    .dept-li{
        flex-shrink: 0;
        flex-grow: 0;
        max-height: 10mm;
        overflow: hidden;

    }
    .page
        {
            width: 100mm;
            height: 70mm;
            padding: 4mm 7mm 4mm 7mm;
            margin: 0 auto;
            border: 1px #D3D3D3 solid;
            border-radius: 5px;
            background: white;
            overflow: hidden;
            color: #000;

            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        }
        .dialog-footer{
            text-align: right;
            margin-bottom: 20px;
        }

        @media print
        {
            *{
                padding: 0px;
                margin: 0px;
            }
            .page
            {
                font-size: 8pt;
                margin: 0;
                border: initial;
                border-radius: initial;
                width: initial;
                min-height: initial;
                box-shadow: initial;
                background: initial;
                page-break-after: always;
            }
        }
</style>
<script>
import request from '@/util/request';
import qrcode from 'qrcodejs2';
import JsBarcode from 'jsbarcode'
import table from '../../../util/table.vue';
const getQrcode = (params, options) =>
request.post('/api/mark/manage/addresses', params,options);
import {getProjectIdValue} from "@/api/wel/home"
export default {
  components: { table },
    data(){
        return{
            loading:false,
            show:false,
            qrcodeList:[],
            moduleType:'',
            liNumberLength:''
        }
    },
    methods:{
        // 打印方法
        print(){
                let dom = document.getElementById('printBox').outerHTML
                var win = window.open();
                self.focus();
                win.document.open();
            let st =     `
                <style >
                .page img{
                    width: 100%;
                    height: 100%;
                }

                li{
                    list-style: none;
                    min-height: 10mm;
                    line-height: 10mm;
                    padding: 0 5px;
                    width: 50mm;
                    border-top: 1px solid #000;

                }
                .tbody-box{
                    display: flex;

                }
                td{
                    padding: 0;
                }
                .tabel{
                    height: 100%;
                    width: 100%;
                    font-weight: bold;
                    border: 1px solid #000;
                }
                .header{
                    display: flex;
                    height: 10mm;
                    line-height: 10mm;
                    font-size: 22px;
                    letter-spacing:4px;
                    justify-content: space-between;
                }
                .td-qrcode{
                    height: 54mm;
                    width: 54mm;
                    margin: 0;
                    padding: 3mm 3mm 3mm 3mm;

                    flex-shrink: 0;
                    flex-grow: 0;
                    border-top: 1px solid #000;

                }
                .td-text{
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    font-size: 22px;
                    border-top: 1px solid #000;
                    border-left: 1px solid #000;
                    flex-shrink: 1;
                    flex-grow: 1;

                }
                .module-li{
                    font-size:16px;
                }
                .first-li{
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    border:none;
                    flex-grow:0;
                    flex-shrink: 0;
                    word-wrap: break-word;
                    word-break: break-all;
                    height:29mm;
                }
                .first-li2{
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical;
                    border:none;
                    flex-grow:0;
                    flex-shrink: 0;
                    word-wrap: break-word;
                    word-break: break-all;
                    height:39mm;
                }
                .last-li{
                    flex-shrink: 0;
                    flex-grow: 0;
                    max-height: 10mm;
                    overflow: hidden;

                }
                .dept-li{
                    flex-shrink: 0;
                    flex-grow: 0;
                    max-height: 10mm;
                    overflow: hidden;
                }
                .page
                    {
                        width: 100mm;
                        height: 70mm;
                        padding: 4mm 7mm 4mm 7mm;
                        margin: 0 auto;
                        border: 1px #D3D3D3 solid;
                        border-radius: 5px;
                        background: white;
                        overflow: hidden;
                        color: #000;

                        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
                    }
                    .dialog-footer{
                        text-align: right;
                        margin-bottom: 20px;
                    }

                    @media print
                    {
                        *{
                            padding: 0px;
                            margin: 0px;
                        }
                        .page
                        {
                            font-size: 8pt;
                            margin: 0;
                            border: initial;
                            border-radius: initial;
                            width: initial;
                            min-height: initial;
                            box-shadow: initial;
                            background: initial;
                            page-break-after: always;
                        }
                    }
            </style>`
                win.document.write('<'+'html'+'>'+st+'<'+'body'+'>');

                win.document.write(dom);
                win.document.write('<'+'/body'+'><'+'/html'+'>');
                win.document.close();
                win.print();
                win.close();

        },

        getQrcodeBydom(index,item){

            setTimeout(()=>{
                let id = "#qrcode"+index;
                let qrcodeItemdiv = document.querySelector(id);
                var qrcodeItem = new qrcode(qrcodeItemdiv, {
                    text: item.urlPath,
                    width:160,
                    height:160,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: qrcode.CorrectLevel.H,
                });
                qrcodeItem.style="height:100%;wight:100%;"
            },0)

        },


        // 获得数据请求方法
        getQrcodes(projectId,moduleType,items){
            this.show = true;
            this.qrcodeList = [];
            this.loading = true;
            let ids = '';
            items.forEach(item=>{
                ids += item.id +',';
            })
            this.show = true;

            setTimeout(()=>{

                getQrcode({
                    projectId:projectId,
                    moduleType:moduleType,
                    ids: ids

                }).then(res=>{

                    this.moduleType = res.data.moduleType;//判断二维码类型 0：设备 1：区域
                    this.qrcodeList = res.data.codePicList;  //二维码list
                    this.loading = false;

                })
            },100)


        }
    }
}
</script>
